define(['app/modules/pdf_viewer', 'app/modules/filteringList'], function(PdfViewer, FilteringList) {

  var Resources = function () {};

  Resources.prototype.actionIndex = function () {
    new FilteringList({
      onSuccess: this.updateList
    });
  };

  Resources.prototype.updateList = function (results) {
    var $list = $('.js-filtering-list');

    if(results.resources_html){
      if(results.clear_content){
        $list.html(results.resources_html);
      } else {
        $list.append(results.resources_html);
      }
    }
  }

  Resources.prototype.actionShow = function () {
    $('.resources-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="fa fa-chevron-left"></button>',
      nextArrow: '<button type="button" class="fa fa-chevron-right"></button>',
      responsive: [
        {
          breakpoint: 988,
          settings: { slidesToShow: 3 }
        }
      ]
    });
  };

  Resources.prototype.actionPdf_viewer = function () {
    var canvasContainer = document.getElementById('pdf-container');
    var url = canvasContainer.getAttribute('data-url');

    PdfViewer.renderPDF(url, canvasContainer);

    $('.zoom-in').on('click', function(e){
      e.preventDefault();
      PdfViewer.zoomIn(canvasContainer);
    });

    $('.zoom-out').on('click', function(e){
      e.preventDefault();
      PdfViewer.zoomOut(canvasContainer);
    });
  };

  return Resources;
});
